import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import age18Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-18.png'
import age40Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-40.png'
import age50Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-50.png'
import age60Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-60.png'

const schema: LandingScreenSchema = {
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('main_walking.lymphatic.age_picker.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-39',
					label: $t('female_yoga.pages.landing.age_range.18_39'),
					img: age18Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: age40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: age50Png,
				},
				{
					// `60_plus_short` is the bare "60+" of the design; the existing `60_plus` renders
					// "Age: 60+". analyticValue keeps the 60-80 bucket from DEV-34798.
					value: 60,
					analyticValue: '60-80',
					label: $t('female_yoga.pages.landing.age_range.60_plus_short'),
					img: age60Png,
				},
			],
		}),
	},
}

export default schema
